/**
 * Browser and third-party errors the production Sentry client drops before sending.
 *
 * Every entry names an event no code of ours raised or can act on. Messages are
 * anchored exact matches and URLs name a host we do not serve, so an error thrown
 * from our own bundles is never swallowed by a looser neighbour.
 */

const ignoreErrors: RegExp[] = [
  // Chrome < 110 wording of the benign ResizeObserver loop notice. It reaches
  // window.onerror with no error object, so it carries no stack to follow. The
  // SDK's defaults only list the newer "loop completed with undelivered
  // notifications" wording.
  /^ResizeObserver loop limit exceeded$/,
  // Chrome's rejection for a body read (json/text/blob) whose AbortController was
  // aborted: a deliberate cancellation, and the DOMException has no stack.
  /^AbortError: The user aborted a request\.$/,
  // An email link scanner (Outlook Safe Links style) that opens shared links
  // and calls back into its own injected bridge, which rejects with this plain
  // object. Our code has no such method dispatch; 10 events, 0 users on /proof.
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+$/,
];

const denyUrls: RegExp[] = [
  // Hotjar's recorder (script.hotjar.com/modules.<hash>.js) JSON.parses its own
  // XHR responses; an HTML error page there is Hotjar's failure, not ours. The
  // SDK tests the innermost frame, so a Hotjar callback that throws inside our
  // code still reports.
  /^https:\/\/(?:script|static)\.hotjar\.com\//,
];

/** Spread into Sentry.init; the SDK's event filters apply both lists. */
export const SENTRY_NOISE_FILTERS = { ignoreErrors, denyUrls };
